import React from 'react';
import Box from '@mui/material/Box';
import { SxProps } from '@mui/material';
import TwCheckbox from '../TwCheckboxes/TwCheckboxes';

export interface TwPhotoThumbnailProps {
  /**
   * Image src
   */
  src: string | undefined;
  /**
   * Can be selected: true or false
   */
  isSelectable?: boolean;
  /**
   * Action to perform on change
   */
  onInputChange?: (e: React.ChangeEvent<HTMLInputElement>) => void | undefined;
  /**
   * Photo id
   */
  photoId: string;
  /**
   * Photo key
   */
  photoKey: string;
  /**
   * Default selected value
   */
  defaultSelected?: boolean;
  /**
   * name for use with Formik
   */
  name?: string;
  /**
   * checked for use with Formik
   */
  checked?: boolean;
  /**
   * Action to perform when thumbnail clicked
   */
  onClick?: () => void;
}

const TwPhotoThumbnail: React.FC<TwPhotoThumbnailProps> = ({
  src,
  photoId,
  photoKey,
  isSelectable,
  onInputChange,
  defaultSelected,
  name,
  checked,
  onClick
}) => {
  const imgStyles: SxProps = {
    cursor: onClick ? 'pointer' : 'inherit',
    borderRadius: '4px',
    width: '100%'
  };

  const containerStyles: SxProps = {
    display: 'flex',
    position: 'relative',
    justifyContent: 'center',
    width: '64px',
    border: '1px solid #DFE4F2',
    borderRadius: '4px',
    height: '64px',
    padding: 0,
    backgroundColor: 'white',
    marginRight: '10px'
  };

  const checkboxStyles: SxProps = {
    position: 'absolute',
    top: '-5px',
    left: '6px',
    zIndex: 1
  };

  const inputBackground: SxProps = {
    position: 'absolute',
    width: '17px',
    height: '17px',
    top: '12px',
    left: '1px',
    backgroundColor: 'white'
  };

  return (
    <Box sx={containerStyles} className="tw-photo-thumbnail">
      {isSelectable && onInputChange && photoId && photoKey && (
        <Box sx={checkboxStyles} className="tw-photo-thumbnail">
          <Box sx={inputBackground}></Box>
          <TwCheckbox
            id={photoId}
            name={name ?? photoKey}
            value={photoId}
            label=""
            defaultChecked={defaultSelected}
            onInputChange={onInputChange}
            checked={checked}
          />
        </Box>
      )}
      <Box onClick={onClick} component="img" sx={imgStyles} src={src} alt={`photo-${name}`} />
    </Box>
  );
};

export default TwPhotoThumbnail;
